export const WS_URL = `${process.env.REACT_APP_SERVER || ''}/ws`;
export const STATES = [
    {
        stateToBeUpdated: 'newRecord',
        path:'/user/topic/update/CoverNoteState'
    },
    {
        stateToBeUpdated: 'newCount',
        path:'/user/topic/update/CoverNoteCount'
    },
];


// WEBPACK FOOTER //
// ./src/Config/websocketConfig.ts